import { render } from "./BioCodeDialogComponent.vue?vue&type=template&id=0f797f8c&scoped=true"
import script from "./BioCodeDialogComponent.vue?vue&type=script&lang=js"
export * from "./BioCodeDialogComponent.vue?vue&type=script&lang=js"

import "./BioCodeDialogComponent.vue?vue&type=style&index=0&id=0f797f8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f797f8c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QLayout,QBtn});
